import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/kpi`

export default {
    async list (params) {
        const response = await Repository.get(`${resource}`, {
            params,
            headers: TokenService.getHeader(),
        })
        return response
    },
    async detail (id) {
        const response = await Repository.get(`${resource}/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async create (kpi) {
        const response = await Repository.post(`${resource}`, kpi, {
            headers: TokenService.getHeader(),
        })
        return response
    },

    async update (id, kpi) {
        const response = await Repository.patch(`${resource}/${id}`, kpi, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async delete (id) {
        const response = await Repository.delete(`${resource}/${id}`, {
            headers: TokenService.getHeader(),
        })
        return response
    },
    async getUserList (id, params) {
        const response = await Repository.get(`${resource}/${id}/user-list`, {
            headers: TokenService.getHeader(),
            params,
        })
        return response
    },
    async saveKpiDetail (id, details) {
        const response = await Repository.post(`${resource}/${id}`, details, {
            headers: TokenService.getHeader(),
        })
        return response
    },
}
